var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
var delay = 2500;
export var Carousel = forwardRef(function Carousel(props, ref) {
    var children = props.children, _a = props.autoplay, autoplay = _a === void 0 ? false : _a, afterChange = props.afterChange;
    var _b = React.useState(0), index = _b[0], setIndex = _b[1];
    var timeoutRef = React.useRef(0);
    var resetTimeout = function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    };
    useImperativeHandle(ref, function () { return ({
        next: function () {
            var newIdx = index + 1 === children.length ? 0 : index + 1;
            setIndex(newIdx);
            if (afterChange)
                afterChange(newIdx);
        },
        prev: function () {
            var newIdx = index - 1 === -1 ? children.length - 1 : index - 1;
            setIndex(newIdx);
            if (afterChange)
                afterChange(newIdx);
        },
    }); });
    React.useEffect(function () {
        if (autoplay) {
            resetTimeout();
            timeoutRef.current = window.setTimeout(function () { return setIndex(function (prevIndex) { return (prevIndex === children.length - 1 ? 0 : prevIndex + 1); }); }, delay);
            if (afterChange)
                afterChange(index);
            return function () {
                resetTimeout();
            };
        }
    }, [index, autoplay]);
    return (_jsxs("div", __assign({ className: "mex-carousel" }, { children: [_jsx("div", __assign({ className: "mex-carousel__slider", style: { transform: "translate3d(".concat(-index * 100, "%, 0, 0)") } }, { children: children.map(function (child, index) { return (_jsx("div", __assign({ className: "mex-carousel__slide" }, { children: child }), index)); }) })), _jsx("div", __assign({ className: "mex-carousel__dots" }, { children: children.map(function (_, idx) { return (_jsx("div", { className: "mex-carousel__dot".concat(idx === index ? " active" : ""), onClick: function () {
                        setIndex(idx);
                        if (afterChange)
                            afterChange(idx);
                    } }, idx)); }) }))] })));
});
Carousel.propTypes = {
    autoplay: PropTypes.bool,
    afterChange: PropTypes.func,
};
Carousel.defaultProps = {
    autoplay: false,
};
export default Carousel;
